<div class="edit-types-container">
  <!-- Header -->
  <div class="edit-types-header">
    <h2 class="edit-types-title">
      <i class="fa fa-pen"></i>
      <span>Edit Category Types</span>
    </h2>
    <button class="close-btn" (click)="closeCurrentOpenModal()" aria-label="Close">
      <i class="fa fa-x"></i>
    </button>
  </div>

  <!-- Group Names Section -->
  <div class="edit-types-section edit-types-section--group-names">
    <h3 class="section-title">
      <i class="fa fa-tags"></i>
      <span>Type Group Names</span>
    </h3>
    <div class="form-grid">
      <div class="form-group">
        <label for="typeOneNaming" class="form-label">
          <i class="fa fa-layer-group"></i>
          Type Group 1 Name
        </label>
        <input
          id="typeOneNaming"
          [(ngModel)]="typeOneNaming"
          type="text"
          class="form-control"
          placeholder="Enter group 1 name (e.g., Categories)"
        />
      </div>
      <div class="form-group">
        <label for="typeTwoNaming" class="form-label">
          <i class="fa fa-layer-group"></i>
          Type Group 2 Name
        </label>
        <input
          id="typeTwoNaming"
          [(ngModel)]="typeTwoNaming"
          type="text"
          class="form-control"
          placeholder="Enter group 2 name (e.g., Services)"
        />
      </div>
    </div>
    <div class="section-actions">
      <button class="btn btn-primary btn-save" (click)="saveCategoryInfo()">
        <i class="fa fa-save"></i>
        <span>Save Group Names</span>
      </button>
    </div>
  </div>

  <!-- Types Management Section -->
  <div class="edit-types-section">
    <h3 class="section-title">
      <i class="fa fa-list"></i>
      <span>Types Management</span>
    </h3>
    
    <!-- Add New Type Form -->
    <div class="add-type-form">
      <div class="compact-form-row first-row mb-1">
        <div class="form-field-group">
          <label for="newType" class="sr-only">Type name</label>
          <input
            id="newType"
            type="text"
            class="form-control compact-input"
            placeholder="Type name"
            [(ngModel)]="newType"
          />
        </div>
        <div class="form-field-group radio-inline my-auto">
          <label class="form-label small-label mr-2">Group</label>
          <label class="radio-label compact-radio">
            <input
              type="radio"
              [(ngModel)]="newTypeGroup"
              [value]="1"
              name="newTypeGroup"
            />
            <span class="radio-custom"></span>
            <span class="radio-text">Group 1</span>
          </label>
          <label class="radio-label compact-radio">
            <input
              type="radio"
              [(ngModel)]="newTypeGroup"
              [value]="2"
              name="newTypeGroup"
            />
            <span class="radio-custom"></span>
            <span class="radio-text">Group 2</span>
          </label>
        </div>
      </div>
      <div class="compact-form-row second-row">
        <div class="form-field-group image-upload-compact">
          <!-- <label class="small-label mr-2">Type Image</label> -->
          <button
            type="button"
            class="btn btn-sm btn-outline-primary image-btn"
            (click)="newTypeImageInput.click()"
            title="Upload image"
          >
            <i class="fa fa-image"></i>
            <span class="d-none d-sm-inline">Upload</span>
          </button>
          <input
            type="file"
            #newTypeImageInput
            class="d-none"
            accept="image/*"
            (change)="onNewTypeImageSelected($event)"
          />
          <div class="image-preview-mini" *ngIf="newTypeImagePreview">
            <img [src]="newTypeImagePreview" alt="Preview" />
            <button
              type="button"
              class="btn-remove-mini"
              (click)="clearNewTypeImage()"
              title="Remove image"
            >
              <i class="fa fa-times"></i>
            </button>
          </div>
        </div>
        <div class="form-field-group">
          <button 
            class="btn btn-success btn-add-compact" 
            (click)="addNewType()"
            *ngIf="!isEditMode"
          >
            <i class="fa fa-plus"></i>
            <span>Add Type</span>
          </button>
          <div class="d-flex edit-buttons-group" *ngIf="isEditMode">
            <button 
              class="btn btn-primary btn-add-compact" 
              (click)="addNewType()"
            >
              <i class="fa fa-save"></i>
              <span>Update</span>
            </button>
            <button 
              class="btn btn-secondary btn-add-compact" 
              (click)="cancelEdit()"
            >
              <i class="fa fa-times"></i>
              <span>Cancel</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Types List -->
    <div class="types-list-container">
      <div class="types-list-header">
        <span class="types-count">
          {{ currentProductCategoryAvailableTypes.length }} Type(s)
        </span>
      </div>
      <div class="types-list" *ngIf="currentProductCategoryAvailableTypes.length > 0; else noTypes">
        <div
          class="type-item"
          *ngFor="let type of currentProductCategoryAvailableTypes"
          [class.active]="selectedTypeToEdit?.id === type.id"
          (click)="selectTypeToEdit(type)"
        >
          <div class="type-item-image" *ngIf="type.image">
            <img [src]="imgUrl + type.image" [alt]="type.name" />
          </div>
          <div class="type-item-content">
            <span class="type-name">{{ type.name }}</span>
            <span class="type-badge" [attr.data-group]="type.type">
              Group {{ type.type }}
            </span>
          </div>
          <button
            class="type-item-delete"
            (click)="removeTypeFromAfterConfirmation($event, type)"
            aria-label="Delete type"
            title="Delete type"
          >
            <i class="fa fa-trash"></i>
          </button>
        </div>
      </div>
      <ng-template #noTypes>
        <div class="empty-state">
          <i class="fa fa-inbox"></i>
          <p>No types available. Add your first type above.</p>
        </div>
      </ng-template>
    </div>
  </div>

  <!-- Sub Types Section -->
  <div class="edit-types-section sub-types-section" *ngIf="selectedTypeToEdit">
    <h3 class="section-title">
      <i class="fa fa-sitemap"></i>
      <span>Sub Types for: <strong>{{ selectedTypeToEdit?.name }}</strong></span>
    </h3>
    
    <!-- Add New Sub Type Form -->
    <div class="add-type-form">
      <div class="form-row">
        <div class="form-group flex-grow-1">
          <label for="newSubType" class="form-label">
            <i class="fa fa-plus-circle"></i>
            New Sub Type Name
          </label>
          <input
            id="newSubType"
            type="text"
            class="form-control"
            placeholder="Enter new sub type name"
            [(ngModel)]="newSubType"
          />
        </div>
        <div class="form-group form-group-actions">
          <button class="btn btn-success btn-add" (click)="addNewSubType()">
            <i class="fa fa-plus"></i>
            <span>Add Sub Type</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Sub Types List -->
    <div class="types-list-container">
      <div class="types-list-header">
        <span class="types-count">
          {{ subTypesOfSelectedType.length }} Sub Type(s)
        </span>
      </div>
      <div class="types-list" *ngIf="subTypesOfSelectedType.length > 0; else noSubTypes">
        <div class="type-item sub-type-item" *ngFor="let subType of subTypesOfSelectedType">
          <div class="type-item-content">
            <span class="type-name">{{ subType.name }}</span>
          </div>
          <button
            class="type-item-delete"
            (click)="removeSubTypeFromAfterConfirmation($event, subType)"
            aria-label="Delete sub type"
            title="Delete sub type"
          >
            <i class="fa fa-trash"></i>
          </button>
        </div>
      </div>
      <ng-template #noSubTypes>
        <div class="empty-state">
          <i class="fa fa-inbox"></i>
          <p>No sub types available. Add your first sub type above.</p>
        </div>
      </ng-template>
    </div>
  </div>
</div>
